var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.data === null)?_c('div',{staticClass:"text-center"},[_c('PulseLoader',{attrs:{"color":"#037cff"}})],1):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }